import { Button, Modal } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { black } from 'styles/Colors';

export const StyledModal = styled((props) => <Modal {...props} />)`
  &&& {
    .MuiPaper-root {
      width: 526px !important;
    }
  }
`;

export const SubmitModalFooter = styled.div`
  display: flex;
  padding: 10px 30px 15px;
`;

export const Controls = styled.div`
  margin-left: auto;
  display: flex;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  margin-left: 16px;
`;

export const Errors = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 92px;
  font-family: Lato;
  font-size: 15px;
  letter-spacing: 0.5px;
  color: ${black};
  text-align: center;
`;
